import SelectDropdownInput from "../SelectDropdown/SelectDropdownInput"

const UserFieldInput = ({ choice_items = [], ...props }) => <SelectDropdownInput options={choice_items} {...props} />

export default UserFieldInput